import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Opentok
import { OTSubscriber } from 'opentok-react';

class BroadCastSubscribers extends Component {
    static propTypes = {
        streams: PropTypes.array,
        sessionHelper: PropTypes.any,
    };
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            showStudents: false,
        };
        this.maxScrollWidth = 0;
        this.carousel = React.createRef();
    }

    // movePrev
    movePrev = () => {
        if (this.state.currentIndex > 0) {
            this.setState((prevState) => ({
                currentIndex: prevState.currentIndex - 1,
            }));
        }
    };

    // moveNext
    moveNext = () => {
        if (
            this.carousel.current !== null &&
            this.carousel.current.offsetWidth * this.state.currentIndex <= this.maxScrollWidth
        ) {
            this.setState((prevState) => ({
                currentIndex: prevState.currentIndex + 1,
            }));
        }
    };

    // shouldShowButtons
    shouldShowButtons = () => {
        if (this.carousel.current !== null) {
            return this.carousel.current.scrollWidth > this.carousel.current.offsetWidth;
        }
        return false;
    };

    // shouldShowLeftIcon
    shouldShowLeftIcon() {
        if (this.carousel.current !== null) {
            return this.carousel.current.scrollLeft > 0;
        }
        return false;
    }

    // shouldShowRightIcon
    shouldShowRightIcon() {
        if (this.carousel.current !== null) {
            const container = this.carousel.current;
            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            return container.scrollLeft < maxScrollLeft;
        }
        return false;
    }

    // componentDidUpdate
    componentDidUpdate() {
        if (this.carousel.current !== null) {
            this.carousel.current.scrollLeft =
                this.carousel.current.offsetWidth * this.state.currentIndex;
            this.maxScrollWidth =
                this.carousel.current.scrollWidth - this.carousel.current.offsetWidth;
        }
    }

    render() {
        const { streams, showStudents } = { ...this.props };
        const showRightIcon = this.shouldShowRightIcon();
        const showLeftIcon = this.shouldShowLeftIcon();
        let isScreenShared = false;
        isScreenShared = streams.some((i) => i.name === 'screen');
        return (
            <>
                {streams && streams.length && showStudents && (
                    <div
                        style={{
                            height: '20%',
                            paddingTop: '4px',
                        }}
                        className="w-full"
                    >
                        <div className="h-full carousel">
                            <div className="relative w-full h-full mb-2 overflow-hidden">
                                <div className="w-full h-full">
                                    <div
                                        ref={this.carousel}
                                        className={`h-full carousel-container relative flex gap-1 overflow-hidden scroll-smooth snap-x snap-mandatory touch-pan-x z-0 ${
                                            !showRightIcon ? 'justify-center' : ''
                                        }`}
                                    >
                                        {streams.map(
                                            (stream, index) =>
                                                ((!isScreenShared && stream.name !== 'Educator') ||
                                                    (isScreenShared &&
                                                        stream.name !== 'Educator' &&
                                                        stream.name !== 'screen')) && (
                                                    <>
                                                        {/* Keep the subscriber mounted when the camera is
                                                            off - unmounting it also tears down the audio
                                                            subscription, which is heard as the voice
                                                            breaking. Hide the tile instead, so the carousel
                                                            layout is unchanged. */}
                                                        <div
                                                            key={index}
                                                            className="relative text-center carousel-item snap-start"
                                                            style={{
                                                                display: stream.hasVideo
                                                                    ? undefined
                                                                    : 'none',
                                                            }}
                                                        >
                                                            <div
                                                                key={stream.id}
                                                                style={{
                                                                    position: 'relative',
                                                                    width: '264px',
                                                                    height: '100%',
                                                                }}
                                                            >
                                                                <OTSubscriber
                                                                    ref={(ref) =>
                                                                        (this.OTSubscriber = ref)
                                                                    }
                                                                    key={stream.id}
                                                                    session={
                                                                        this.props.sessionHelper
                                                                            .session
                                                                    }
                                                                    stream={stream}
                                                                    eventHandlers={
                                                                        this
                                                                            .subscriberEventHandlers
                                                                    }
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                        )}
                                    </div>
                                    {showLeftIcon && (
                                        <button
                                            onClick={this.movePrev}
                                            style={{ display: showLeftIcon ? 'block' : 'none' }}
                                            className="absolute top-0 left-0 z-20 w-10 h-full p-0 m-0 text-center text-white transition-all duration-300 ease-in-out opacity-75 hover:bg-blue-900/75 hover:opacity-100"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-20 h-12 -ml-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M15 19l-7-7 7-7"
                                                />
                                            </svg>
                                            <span className="sr-only">Prev</span>
                                        </button>
                                    )}
                                    {showRightIcon && (
                                        <button
                                            onClick={this.moveNext}
                                            style={{
                                                display: showRightIcon ? 'block' : 'none',
                                            }}
                                            className="absolute top-0 right-0 z-20 w-10 h-full p-0 m-0 text-center text-white transition-all duration-300 ease-in-out opacity-75 hover:bg-blue-900/75 hover:opacity-100"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="w-20 h-12 -ml-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    d="M9 5l7 7-7 7"
                                                />
                                            </svg>
                                            <span className="sr-only">Next</span>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        {this.props.renderLogoWithWifi()}
                    </div>
                )}
            </>
        );
    }
}

export default BroadCastSubscribers;
